import axios from "axios";

import type { AxiosRequestConfig } from "axios";

class ApiService {
  #baseURL: string;

  #token: string | null = null;

  constructor() {
    this.#baseURL = import.meta.env.REACT_APP_API_URL ?? "";
  }

  setToken(token: string | null) {
    this.#token = token;
  }

  async request<T>(
    method: HTTPRequestMethod,
    url: string,
    requestBody?: unknown,
  ): Promise<AxiosResponse<T>> {
    if (this.#token == null) {
      throw new Error("No authentication token available");
    }

    const config: AxiosRequestConfig = {
      method,
      url: this.#baseURL + url,
      headers: { Authorization: `Bearer ${this.#token}` },
    };

    if (requestBody) {
      config.data = requestBody;
    }

    return axios.request(config).catch((e) => {
      if (e?.response?.status === 401) {
        throw new Error("401 status code received from API.");
      }
      throw e;
    });
  }

  async unauthenticatedRequest<T>(
    method: "get" | "post" | "patch" | "delete" | "put",
    url: string,
    requestBody?: unknown,
  ): Promise<AxiosResponse<T>> {
    const config: AxiosRequestConfig = {
      method,
      url: this.#baseURL + url,
    };

    if (requestBody) {
      config.data = requestBody;
    }
    return axios.request(config);
  }
}

export const apiService = new ApiService();
